<div class="no-results-container">
  <div class="font-title-small" i18n>No Results</div>
  <div class="mt-3" i18n>Adjust your filters to see more results.</div>
  <lib-button
    class="d-block mt-4"
    [type]="ButtonType.secondary"
    [size]="InputSize.small"
    (buttonClick)="adjustFiltersClicked.emit()"
    i18n>
    Adjust Filters
  </lib-button>
</div>
